import { LoanOffer } from '../../interfaces';
import { LoanOffersAction } from '../actions/loan.actions';
import { ActionType } from '../action_types';

interface LoanOfferState {
  loanOffers: LoanOffer[];
}

const initialState: LoanOfferState = {
  loanOffers: [],
};

const loanOfferReducer = (state = initialState, action: LoanOffersAction): LoanOfferState => {
  switch (action.type) {
    case ActionType.LOAN_OFFERS:
      return {
        ...state,
        loanOffers: action.payload.loanOffers,
      };
    case ActionType.ADD_LOAN_OFFER:
      return {
        ...state,
        loanOffers: [action.payload.loanOffer, ...state.loanOffers],
      };
    case ActionType.UPDATE_LOAN_OFFERS:
      return {
        ...state,
        loanOffers: [action.payload.loanOffer, ...state.loanOffers.filter((offer) => offer.id !== action.payload.loanOffer.id)],
      };
    default:
      return { ...state };
  }
};

export default loanOfferReducer;
